import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet
} from "@react-pdf/renderer";
import chunk from "lodash/chunk";

// Styling
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 8,
    fontFamily: "Helvetica",
    position: "relative",
  },
  title: {
    fontSize: 12,
    marginBottom: 10,
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: 10,
    marginTop: 6,
    marginBottom: 2,
    fontWeight: "bold",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: "#000",
    paddingVertical: 3,
    backgroundColor: "#eee",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderColor: "#ccc",
    paddingVertical: 2,
  },
  footerRow: {
    flexDirection: "row",
    backgroundColor: "#f9f9f9",
    borderTopWidth: 1,
    borderColor: "#000",
    paddingTop: 2,
  },
  cell: {
    paddingHorizontal: 3,
  },
  colChartCode: { width: '20%' },
  colChartDesc: { width: '80%' },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    top: 10,
    right: 30,
    textAlign: 'right',
    color: 'grey',
  },
});

// Grouping function
const groupBy = (arr, key1, key2) => {
  return arr.reduce((acc, item) => {
    const groupKey = `${item[key1]}||${item[key2]}`;
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
};

// Main component
const MyReportCoA = ({ data = [], userBy = "Admin" }) => {
  const groupedData = groupBy(data, "group_account_code", "group_account_desc");
  const date = new Date().toLocaleString("id-ID", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const rows = [];

  Object.entries(groupedData).forEach(([key, records]) => {
    const [groupCode, groupDesc] = key.split("||");

    // Group title
    rows.push(
      <Text key={`${key}-title`} style={styles.sectionTitle}>
        {groupCode} - {groupDesc}
      </Text>
    );

    // Rows of chart accounts
    records.forEach((r, i) => {
      rows.push(
        <View style={styles.tableRow} key={`${key}-row-${i}`}>
          <Text style={[styles.cell, styles.colChartCode]}>{r.chart_account_code}</Text>
          <Text style={[styles.cell, styles.colChartDesc]}>{r.chart_account_desc}</Text>
        </View>
      );
    });

    // Optional spacer
    rows.push(
      <View style={styles.footerRow} key={`${key}-footer`} />
    );
  });

  const rowsPerPage = 50;
  const pages = chunk(rows, rowsPerPage);

  return (
    <Document>
      {pages.map((chunkedRows, idx) => (
        <Page key={idx} size="A4" orientation="portrait" style={styles.page}>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `Halaman: ${pageNumber} dari ${totalPages}`
            }
            fixed
          />
          <Text style={styles.title}>Laporan Chart of Account</Text>
          <Text>Tanggal : {date} | User by : {userBy}</Text>

          <View style={styles.tableHeader} fixed>
            <Text style={[styles.cell, styles.colChartCode]}>Chart Code</Text>
            <Text style={[styles.cell, styles.colChartDesc]}>Chart Desc</Text>
          </View>

          {chunkedRows}
        </Page>
      ))}
    </Document>
  );
};

export default MyReportCoA;
